<template>
    <h1>Not found</h1>
</template>

<script>
export default {
    
}
</script>